import React, { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useFormikContext } from 'formik';

import { DroneContext, FormContext, OrganisationContext } from 'contexts';
import { DroneRegistrationFormData, FinalStepProps } from 'types/forms/droneRegistrationTypes';
import { AuDirectionLink } from 'components/DTA';

const FinalStep: React.FC<FinalStepProps> = ({ successful = true, isRenewal = false }) => {
  const userDetails = useSelector((state: any) => state.userdetails);
  const { organisationDetailsResponse } = useContext(OrganisationContext);
  const { setFormAlert } = useContext(FormContext);
  const { dashboardUrl, isOrganisationRegistration } = useContext(DroneContext);
  const { resetForm } = useFormikContext<DroneRegistrationFormData>();

  // runs on the first render
  useEffect(() => {
    resetForm(); // reset formik form so exit modal is not triggered
    if (successful) {
      setFormAlert({
        as: 'success',
        title: !isRenewal ? 'Registration successful' : 'Renewal successful',
        message: ''
      });
    }
    else {
      setFormAlert({
        as: 'error',
        title: 'Unable to complete application online',
        message: 'Unfortunately this application cannot be completed online at this time, please try again or contact CASA for further information.'
      });
    }
  }, []);

  const handleBackToDashBoard = () => {
    window.location.href = dashboardUrl;
  };

  return (
    <>
      {
        successful &&
        <>
          <p>Thank you {userDetails?.items?.value[0].fullname},</p>
          <p>{!isRenewal ? 'You have registered your drone(s) (RPA) with CASA.' : 'Your drone(s) (RPA) have had their registration renewed by CASA.'} A receipt has been sent to your email address <strong>{isOrganisationRegistration ? organisationDetailsResponse?.value?.value[0]?.emailaddress1 : userDetails?.items?.value[0].emailaddress1}</strong>.</p>
          <p>You can download your Certificate of Registration under the <i>Manage registered drones</i> section in myCASA.</p>
          <p>Important:</p>
          <ul>
            <li>Make sure anyone operating your registered drone holds the appropriate <a href='https://www.casa.gov.au/node/1552179' target='_blank' rel='noopener noreferrer'>operator accreditation or licence</a>.</li><br />
            <li>To find out where you can and can&apos;t fly, download a <a href='https://www.casa.gov.au/node/917361' target='_blank' rel='noopener noreferrer'>CASA-verified drone safety app</a>.</li><br />
            <li>Any drone(s) recorded as &apos;foreign registered&apos; is not registered in Australia. Instead, this type of drone(s) are authorised to be flown and operated in Australia. This authorisation is not a substitute for the operator to hold an operator accreditation, remote pilot licence or remotely piloted aircraft operator&apos;s certificate.</li><br />
            <li>Any drone without a serial number must have a CASA-generated registration mark affixed to it. Tips about how to do this are on the <a href='https://www.casa.gov.au/node/917361' target='_blank' rel='noopener noreferrer'>CASA website</a>. Your CASA-generated registration mark can be found on your Certificate of Registration or from the Manage registered drones section of myCASA.</li><br />
          </ul>
          <br />
        </>
      }
      <AuDirectionLink onClick={handleBackToDashBoard} text='Return to myCASA' direction='left' className='au-form-group' />
    </>
  );

};

export default FinalStep;